module.exports = __webpack_public_path__ + "static/media/aladdin.b6702ace.jpg";